export default function Banner() {
  return (
    <div className="w-full flex items-center justify-center h-6 bg-[var(--bg)] border-b border-[var(--bg-lighter)]  overflow-hidden">
         {/* <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[var(--foreground)] shadow-[0_0_10px_2px_rgba(255,255,255,0.6)]" /> */}
      <div className="relative z-10 ">
       

        <div className="max-w-6xl mx-auto text-center">
          <p className="flex items-center justify-center gap-2">
            <span className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-[var(--green-dark)] opacity-75 animate-ping"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[var(--green)]"></span>
              </span>
            </span>
            <span className="font-sans text-[var(--foreground)] text-sm font-regular tracking-widest">Markets are live</span>
          </p>
        </div>
      </div>
    </div>
  );
}